var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6777 37.1212C38.7799 37.2234 38.8609 37.3448 38.9162 37.4783C38.9715 37.6118 39 37.7549 39 37.8994C39 38.044 38.9715 38.1871 38.9162 38.3206C38.8609 38.4541 38.7799 38.5755 38.6777 38.6777C38.5755 38.7799 38.4541 38.8609 38.3206 38.9162C38.1871 38.9715 38.044 39 37.8994 39C37.7549 39 37.6118 38.9715 37.4783 38.9162C37.3448 38.8609 37.2234 38.7799 37.1212 38.6777L28 29.555L18.8788 38.6777C18.6724 38.884 18.3924 39 18.1006 39C17.8087 39 17.5287 38.884 17.3223 38.6777C17.116 38.4713 17 38.1913 17 37.8994C17 37.6076 17.116 37.3276 17.3223 37.1212L26.445 28L17.3223 18.8788C17.116 18.6724 17 18.3924 17 18.1006C17 17.8087 17.116 17.5287 17.3223 17.3223C17.5287 17.116 17.8087 17 18.1006 17C18.3924 17 18.6724 17.116 18.8788 17.3223L28 26.445L37.1212 17.3223C37.3276 17.116 37.6076 17 37.8994 17C38.1913 17 38.4713 17.116 38.6777 17.3223C38.884 17.5287 39 17.8087 39 18.1006C39 18.3924 38.884 18.6724 38.6777 18.8788L29.555 28L38.6777 37.1212Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.04c73cfa2245b229ea8a8078ab4e7d10.svg";
export { ForwardRef as ReactComponent };